/* sun matters · PDP Kaufbereich – gallery, variants, price (subline + add-to-cart button), tabs, sticky bar */
(function () {
  function init() {
    var root = document.querySelector('[data-sm-pdp]');
    if (!root) return;
    var form = root.querySelector('[data-sm-main-form] form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var btn = root.querySelector('[data-add-button]');
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: root.dataset.currency || 'EUR' }); } catch (e) { fmt = null; }
    function money(c) { return fmt ? fmt.format(c / 100) : (c / 100).toFixed(2); }

    /* Add-to-cart label always shows the price (apps like Loop rewrite the button text) */
    var state = { price: Number(root.dataset.price || 0), available: btn ? !btn.disabled : true };
    function desired() { return state.available ? root.dataset.add + ' – ' + money(state.price) : root.dataset.sold; }
    function getLabel() { return btn ? (btn.querySelector('[data-add-label]') || btn.querySelector('span')) : null; }
    function setLabel() {
      if (!btn) return;
      var l = getLabel();
      if (!l) { l = document.createElement('span'); l.setAttribute('data-add-label', ''); btn.prepend(l); }
      if (l.textContent.trim() !== desired()) l.textContent = desired();
    }
    if (btn && 'MutationObserver' in window) {
      new MutationObserver(function () { setLabel(); }).observe(btn, { childList: true, subtree: true, characterData: true });
    }
    setLabel();
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'selling_plan') return;
      setTimeout(setLabel, 0);
    });

    /* Gallery */
    var slides = root.querySelector('[data-slides]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function activate(i) { thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); }); }
    function go(i) {
      var s = slides && slides.children[i];
      if (!s) return;
      slides.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      activate(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.thumb)); }); });
    if (slides && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) activate(Array.prototype.indexOf.call(slides.children, en.target));
        });
      }, { root: slides, threshold: [0.6] });
      Array.prototype.forEach.call(slides.children, function (s) { io.observe(s); });
    }

    /* Tabs */
    root.querySelectorAll('[data-sm-tabs]').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('[data-tab]');
      var panels = tabs.querySelectorAll('[data-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.dataset.panel !== b.dataset.tab; });
        });
      });
    });

    /* Variants (e.g. Glow Serum Silk / Bronze) */
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var mainPrice = root.querySelector('[data-main-price]');
    var mainCompare = root.querySelector('[data-main-compare]');
    var vEl = root.querySelector('[data-sm-variants]');
    if (vEl) {
      var variants = JSON.parse(vEl.textContent);
      var subs = {};
      try { subs = JSON.parse(root.querySelector('[data-sm-subtitles]').textContent); } catch (e) {}
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-option-value]');
        if (!b) return;
        var group = b.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        var sel = Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (g) {
          var a = g.querySelector('.is-active'); return a ? a.dataset.optionValue : null;
        });
        var vv = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!vv) return;
        if (idInput) idInput.value = vv.id;
        if (btn) btn.disabled = !vv.available;
        state.price = vv.price; state.available = vv.available; root.dataset.price = vv.price;
        setLabel();
        if (stickyPrice) stickyPrice.textContent = money(vv.price);
        if (mainPrice) mainPrice.textContent = money(vv.price);
        if (mainCompare) {
          if (vv.compare_at_price && vv.compare_at_price > vv.price) { mainCompare.hidden = false; mainCompare.textContent = money(vv.compare_at_price); }
          else { mainCompare.hidden = true; }
        }
        var st = root.querySelector('[data-subtitle]'); if (st && subs[vv.id]) st.textContent = subs[vv.id];
        if (vv.featured_media && slides) {
          var idx = Array.prototype.findIndex.call(slides.children, function (s) { return s.dataset.mediaId == vv.featured_media.id; });
          if (idx > -1) go(idx);
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', vv.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    /* Sticky add-to-cart: visible while the main button is out of view */
    var sticky = root.querySelector('[data-sticky]');
    var sBtn = root.querySelector('[data-sticky-btn]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }, { threshold: 0 }).observe(btn);
      if (sBtn) sBtn.addEventListener('click', function () { btn.click(); });
    }

    /* Rating link scrolls to reviews */
    var toReviews = root.querySelector('[data-to-reviews]');
    if (toReviews) {
      toReviews.addEventListener('click', function (e) {
        var t = document.getElementById('sm-reviews') || document.querySelector('#judgeme_product_reviews');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();